// extracted by mini-css-extract-plugin
module.exports = {"orders":"Orders_orders__2wn3y","hidden":"Orders_hidden__3dPr-","overflowHidden":"Orders_overflowHidden__1ygC-"};